import { poisResponse } from "./types";

export const poisKeys = {
  all: () => ["pois"] as const,
  list: (filters: Partial<poisResponse>) =>
    [...poisKeys.all(), filters] as const,
};
